import api from '@/plugins/api'
import {techSupport} from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'
import notify from '@ananasbear/notify'
const store = 'techSupport'

export default {
  state: () => ({
    inquiry: null
  }),

  actions: {
    async clearInquiryTechSupport (context) {
      context.commit('SET_DATA', { store, state: 'inquiry', data: null })
    },

    async postInquiryTechSupport (context, data) {
      const body = new FormData()
      body.append('additional_email', data.additional_email)
      body.append('error_url', data.error_url)
      body.append('from_url', data.from_url)
      body.append('statement_number', data.statement_number)
      body.append('text', data.text)
      data.upload_files.forEach(file => {
        body.append('upload_files', file)
      })

      const response = await api.post(`${techSupport.inquiry}`, { body: body })
      if (response.code === 400) {
        const error = await response.data.json()
        context.commit('SET_DATA', { store, state: 'inquiry', data: { error: true, ...{ error_field: error } } })
        notify.error('techSupport.inquiryError')
      } else {
        if (await requestValidation(response)) {
          context.commit('SET_DATA', { store, state: 'inquiry', data: response.data })
          notify.success('techSupport.inquirySuccess')
        }
      }
    }
  }
}
